module.exports = __webpack_public_path__ + "assets/img/title-34f256a3.png";